<template>
	<div class="body">
		<header class="header-section">
			<h1 class="main-title">📖 电子书推荐</h1>
      		<h1 class="main-title">看见文字的力量</h1>
			<div class="subtitle-wrapper">
				<span class="subtitle-badge">阅读</span>
				<span class="subtitle-badge">思考</span>
				<span class="subtitle-badge">启发</span>
			</div>
		</header>

		<!-- <section class="quote-card">
			<p class="p-highlight">你选择慢下来，与文字同行。</p>
			<p class="p-content">每一次阅读，都是一次视野的延伸。</p>
			<div class="p-content">
				<p>当思维被打开，成长也会悄然发生。</p>
			</div>
		</section> -->

		<div class="wrapper">
			<div v-for="(book, index) in books" :key="index" class="book-card" :class="{ 'is-selected': selectedCourses.includes(book.title) }">
				<div class="book-header">
					<label class="custom-checkbox">
						<input type="checkbox" :value="book.title" v-model="selectedCourses" />
						<span class="checkmark"></span>
						<span class="book-title">{{ book.title }}</span>
					</label>
				</div>
				
				<div class="book-info">
					<p class="book-author">{{ book.author }}</p>
					<div class="book-desc" v-html="book.description"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		ReportData: { type: Object, required: false },
		selected: { type: Array, default: () => [] }
	},
	data() {
		return {
		selectedCourses: [],
		books: [
			{
                title: '改变世界的机器',
                author: '沃麦克',
                description: `本书以汽车工业为例，说明世界并不是面临供大于求的危机，而是面临着严重缺乏具有竞争力的精益生产方式的生产能力的危机。在各工业界普遍采用精益生产方式后，将会改变消费者的选择、工作的涵义、公司的命运、世界的经济等诸多方面的重大变化。`,
			},
			{
                title: '精益思想',
                author: '（美）詹姆斯 P.沃麦克/ （英）丹尼尔 T.琼斯',
                description: `本书为读者提供了精益的核心原则，实地考察了美国、德国、日本若干具有代表性的大小企业推行精益的实际情况和心得，为准备跨入精益之门和进一步学习、实施精益的人提供了最好的指南，从而成为精益方面的经典著作。`,
			}
		]
		};
	},
	watch: {
        selectedCourses: {
            deep: true,
            handler(newVal) { 
                this.$emit('update:selected', newVal); 
            }
		}
	},
	mounted() {
		this.selectedCourses = [...this.selected];
	}
};
</script>

<style scoped>
/* 年度报告风格 · 深色书单页（暖金调） */
/* 基础容器 */
.body {
	position: relative;
	background:
		url("../../assets/26June/logo.png") right top no-repeat,
		url("../../assets/26September/bg.png") no-repeat center / cover;
	background-size: 100px 32px, cover;
	background-color: #1a0810;
	width: 100%;
	height: 100vh;
	display: flex;
	flex-direction: column;
	align-items: center;
	overflow: hidden;
	color: #2d1505;
	box-sizing: border-box;
	padding: 20px 0;
	text-shadow: 0 0 3px rgba(255, 240, 210, 0.5), 0 1px 2px rgba(255, 240, 210, 0.3);
}

.body * {
	text-shadow: 0 0 3px rgba(255, 240, 210, 0.5), 0 1px 2px rgba(255, 240, 210, 0.3);
}

/* 头部 */
.header-section {
  position: relative;
  z-index: 2;
  padding-top: 5vh;
  text-align: center;
  margin-bottom: 18px;
}
.main-title {
  font-size: 25px;
  color: #4a9eff;
  margin: 0;
  font-weight: 800;
  letter-spacing: 2px;
}
/* .main-title:first-child {
  background: linear-gradient(180deg, #7cc8ff, #4a9eff 60%, #2d7dd6);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.6));
  margin-bottom: 4px;
} */
.subtitle-wrapper {
  margin-top: 10px;
  display: flex;
  gap: 10px;
  justify-content: center;
}
.subtitle-badge {
  font-size: 14px;
  background: rgba(74, 158, 255, 0.1);
  border: 1px solid rgba(74, 158, 255, 0.35);
  color: #121313;
  padding: 3px 12px;
  border-radius: 20px;
  letter-spacing: 1px;
}

/* 引用卡片（模板中暂未使用，保留适配） */
.quote-card {
  position: relative;
  z-index: 2;
  width: 88%;
  background: rgba(255, 245, 230, 0.15);
  border: 1px solid rgba(80, 40, 15, 0.2);
  border-left: 3px solid #4a9eff;
  padding: 14px 16px;
  margin-bottom: 18px;
  border-radius: 14px;
}
.p-highlight {
  font-weight: 700;
  color: #7cc8ff;
  margin: 0 0 5px 0;
}
.p-content {
  font-size: 13.5px;
  color: rgba(45, 20, 5, 0.85);
  line-height: 1.5;
}

/* 书籍列表区域：核心滚动区 */
.wrapper {
  position: relative;
  z-index: 2;
  flex: 1;
  width: 90%;
  overflow-y: auto;
  padding: 5px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  scrollbar-width: thin;
}

/* 书籍卡片 */
.book-card {
  background: rgba(255, 245, 230, 0.15);
  border: 1.5px solid rgba(80, 40, 15, 0.2);
  border-radius: 16px;
  padding: 14px 16px;
  transition: all 0.3s ease;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.22), inset 0 1px 0 rgba(255, 255, 255, 0.05);
}
.book-card.is-selected {
  border-color: rgba(74, 158, 255, 0.75);
  background: rgba(74, 158, 255, 0.1);
  box-shadow: 0 12px 30px rgba(74, 158, 255, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.08);
  transform: translateY(-2px);
}

.book-header {
  margin-bottom: 6px;
}
.book-title {
  font-size: 17px;
  font-weight: 700;
  color: rgba(45, 20, 5, 0.92);
  letter-spacing: 0.5px;
}

.book-author {
  font-size: 12px;
  color: #379de7;
  background: rgba(74, 158, 255, 0.12);
  border: 1px solid rgba(74, 158, 255, 0.25);
  display: inline-block;
  padding: 2px 9px;
  border-radius: 6px;
  margin-bottom: 7px;
}
.book-desc {
  font-size: 13.5px;
  color: rgba(45, 20, 5, 0.85);
  line-height: 1.65;
  text-align: justify;
}

/* 自定义复选框 */
.custom-checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 10px;
}
.custom-checkbox input {
  display: none;
}
.checkmark {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(53, 50, 50, 0.3);
  border-radius: 50%;
  display: inline-block;
  position: relative;
  flex-shrink: 0;
  transition: all 0.3s;
}
.custom-checkbox input:checked + .checkmark {
  background: linear-gradient(135deg, #a8d8ff, #2d7dd6);
  border-color: #4a9eff;
  box-shadow: 0 0 10px rgba(74, 158, 255, 0.6);
}
.custom-checkbox input:checked + .checkmark::after {
  content: '✓';
  color: #ffffff;
  font-weight: 900;
  font-size: 13px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.footer-hint {
  font-size: 12px;
  color: rgba(45, 20, 5, 0.5);
  margin-top: 10px;
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-5px); }
}

/* PC 端适配 */
@media screen and (min-width: 786px) {
  .body {
        background:
            url("../../assets/26June/logo.png") right top no-repeat,
            url("../../assets/26September/pcbg.png") no-repeat center / cover;
        background-size: 110px 35px, cover;
        width: 100% !important;
        height: 100vh !important;
        padding: 60px 10%;
        border-radius: 0 !important;
        box-shadow: none !important;
        border: none !important;
    }
    .main-title {
        font-size: 32px;
    }
    .subtitle-badge {
        font-size: 20px;
    }
    .course-name {
        font-size: 20px;
    }
    .p-highlight {
        font-size: 24px;
        font-weight: 700;
        color: #095b96;
    }
    .book-title {
      font-size: 24px;
      
    }

    .book-author {
      font-size: 18px;
      color: #1e90e2;
    }
    .book-desc {
      font-size: 18px;
      color: rgba(45, 20, 5, 0.85);
      line-height: 1.65;
      text-align: justify;
    }
    .p-content {
        font-size: 24px;
        color: rgba(45, 20, 5, 0.85);
    }
    .quote-card, .wrapper {
        width: 600px;
    }
}
</style>